import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import BaseImage from '~/components/base/Image';
import BaseLink from '~/components/base/BaseLink';

const FigCaption = styled.figcaption`
    font-size: 0.85em;
    text-align: ${({ align }) => align};
    margin-top: 10px;
`;

const Figure = styled.figure`
    display: block;

    text-align: ${({ align }) => align || 'left'};
    width: ${({ width }) => (width ? `${width}px` : 'auto')};
    height: ${({ height }) => (height ? `${height}px` : 'auto')};
    aspect-ratio: ${({ aspectRatio }) => (aspectRatio ? aspectRatio : 'auto')};

    max-width: ${({ align }) => (align === 'center' ? '105%' : '100%')};
    margin-left: ${({ align }) => (align === 'center' ? '2.5%' : '')};
    margin-right: ${({ align }) => (align === 'center' ? '2.5%' : '')};
    margin-top: 35px;
    margin-bottom: 35px;

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        max-width: ${({ align }) => (align === 'center' ? '120%' : '100%')};
        margin-left: ${({ align, width }) =>
            width ? 'auto' : align === 'center' ? '10%' : ''};
        margin-right: ${({ align, width }) =>
            width ? 'auto' : align === 'center' ? '10%' : ''};
        margin-top: 50px;
        margin-bottom: 50px;
    }

    .is-style-rounded {
        border-radius: 18px;
    }
`;

const Div = styled.div``;

const Image = ({
    align = '',
    altText = '',
    anchor = '',
    localFile,
    url,
    width = null,
    height = null,
    caption = '',
    className = '',
    scale = 'cover',
    aspectRatio = '',
    href = '',
    linkTarget = ''
}) => {
    const ImageWrapper = href ? BaseLink : Div;
    return (
        <Figure {...{ align, width, height, aspectRatio }}>
            <ImageWrapper to={href} external={linkTarget === '_blank'}>
                <BaseImage
                    {...{ altText, localFile, className }}
                    {...(anchor ? { id: anchor } : {})}
                    objectFit={scale}
                    sourceUrl={url}
                />
            </ImageWrapper>

            {caption && <FigCaption {...{ align }}>{caption}</FigCaption>}
        </Figure>
    );
};

Image.propTypes = {
    align: PropTypes.string,
    altText: PropTypes.string,
    anchor: PropTypes.string,
    caption: PropTypes.string,
    className: PropTypes.string,
    localFile: PropTypes.shape({
        childImageSharp: PropTypes.object.isRequired
    }).isRequired,
    url: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    scale: PropTypes.string,
    aspectRatio: PropTypes.string,
    href: PropTypes.string,
    linkTarget: PropTypes.string
};

export default Image;
